import React from "react";

// Slow editorial marquee — outline Chivo text for the operational flow.
export function Marquee({ items, className = "" }) {
  const seq = [...items, ...items];
  return (
    <div className={`relative w-full overflow-hidden py-8 ${className}`} aria-hidden="true">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {seq.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading text-4xl md:text-6xl font-black uppercase tracking-tight text-outline px-8">
              {item}
            </span>
            <span className="text-astro-blue text-3xl md:text-5xl">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
